import Scene from '@scene';
import { APP_TYPES } from '@config';

import { resetPanel, setPanelState } from "@reducers/options/panel/actions";
import { resetScrew, setScrewState } from '@reducers/options/screw/actions';
import { resetBeam, setBeamState } from '@reducers/options/beam/actions';
import { resetGround, setGroundState } from '@reducers/options/ground/actions';
import { resetCamera } from '@reducers/camera/actions';
import { resetReinforcement, setReinforcementState } from '@reducers/options/reinforcement/actions';
import { resetNail, setNailState } from '@reducers/options/nail/actions';
import { resetBarrier, setBarrierState } from './barrier/actions';
import { resetOrientation } from '@reducers/actions';
import { resetCladding, setCladdingState } from './cladding/actions';

export const SET_OBJECT_TYPE = 'SET_OBJECT_TYPE';
export const RESET_OPTIONS = 'RESET_OPTIONS';
export const SHOW_LOADS = 'SHOW_LOADS';
export const HIDE_LOADS = 'HIDE_LOADS';
export const ALLOW_EDIT_LOADS = 'ALLOW_EDIT_LOADS';
export const SET_OPTIONS_STATE = 'SET_OPTIONS_STATE';
export const RESET_OPTIONS_STATE = 'RESET_OPTIONS_STATE';
export const SET_OBJECT_STATE = 'SET_OBJECT_STATE';
export const SHOW_3D_DIMENSIONS = 'SHOW_3D_DIMENSIONS';
export const HIDE_3D_DIMENSIONS = 'HIDE_3D_DIMENSIONS';
export const SWITCH_3D_DIMENSIONS_REPORT = 'SWITCH_3D_DIMENSIONS_REPORT';
export const SHOW_3D_LABELS = 'SHOW_3D_LABELS';

/*
  Action creators
 */
export function setObjectType(objectType) {
  return (dispatch) => {
    dispatch({ type: SET_OBJECT_TYPE, objectType });

    Scene.updateObjectType(objectType);
  };
}

export function setOptionsState(state) {
  return dispatch => {
    dispatch(setGroundState(state.ground));
    dispatch(setPanelState(state.panel));
    dispatch(setScrewState(state.screw));
    dispatch(setBeamState(state.beam));
    dispatch(setReinforcementState(state.reinforcement));
    dispatch(setBarrierState(state.barrier));
    dispatch(setNailState(state.nail));
    dispatch(setObjectState(state.object));
    dispatch(setCladdingState(state.cladding));

    dispatch({ type: SET_OPTIONS_STATE, state: state.object });
  };
}

export function resetOptions() {
  return (dispatch, getState) => {
    const { appType } = getState().main;

    dispatch(resetOptionsObject());
    dispatch(resetPanel(appType));
    dispatch(resetScrew(appType));
    dispatch(resetGround(appType));
    dispatch(resetReinforcement());
    dispatch(resetCamera(appType));
    dispatch(resetBeam(appType));
    dispatch(resetBarrier());
    dispatch(resetNail());
    dispatch(resetOrientation());
    dispatch(resetCladding());

    Scene.updateAppType(appType, {
      ...getState().options,
      mode: getState().main.mode,
      designStandard: getState().main.localization.designStandard,
      orientation: getState().main.orientation
    });
  };
}

export function showLoads() {
  return (dispatch, getState) => {
    const { appType } = getState().main;

    if (appType === APP_TYPES.BRACKET_ATTACHMENT || appType === APP_TYPES.SAFETY_BARRIER || 
      appType === APP_TYPES.REBAR_REINFORCEMENT || appType === APP_TYPES.WOOD_CONNECTION) {
      dispatch({ type: SHOW_LOADS });
    }

    if (appType === APP_TYPES.GENERAL_CALCULATION) {
      // TODO: Show and hide general calculation loads
    }

    Scene.updateObject(getState().options);
  };
}
export function hideLoads() {
  return (dispatch, getState) => {
    dispatch({ type: HIDE_LOADS });

    Scene.updateObject(getState().options);
  };
}
export function allowEditLoads(value) {
  return (dispatch, getState) => {
    dispatch({ type: ALLOW_EDIT_LOADS, value });

    Scene.updateObject(getState().options);
  };
}
export function show3DDimensions() {
  return (dispatch, getState) => {
    if (getState().options.object.dimensions.display === false) {
      dispatch({ type: SHOW_3D_DIMENSIONS });
      Scene.updateObject(getState().options);
    }
  };
}
export function hide3DDimensions() {
  return (dispatch, getState) => {
    if (getState().options.object.dimensions.display === true) {
      dispatch({ type: HIDE_3D_DIMENSIONS });
      Scene.updateObject(getState().options);
    }
  };
}
export function switchToReport3DDimensions(beforeReport) {
  return (dispatch, getState) => {
    if (beforeReport) {
      let value = getState().selectors.calculate.report.showDim3d;
      dispatch({ type: SWITCH_3D_DIMENSIONS_REPORT, value, beforeReport });
    } else {
      dispatch({ type: SWITCH_3D_DIMENSIONS_REPORT, beforeReport });
    }
    Scene.updateObject(getState().options);
  };
}
export function show3DLabels(value) {
  return (dispatch, getState) => {
    if (getState().options.object.dimensions.showLabels !== value) {
      dispatch({ type: SHOW_3D_LABELS, value });
      Scene.updateObject(getState().options);
    }
  };
}

export function resetOptionsObject() {
  return (dispatch, getState) => {
    dispatch({ type: RESET_OPTIONS_STATE });

    // the settings are for all applications and they should not reset
    dispatch(show3DLabels(getState().main.dimensions.showLabels));

    Scene.updateObject(getState().options);
  };
}

export function setObjectState(value) {
  return { type: SET_OBJECT_STATE, value};
}



// WEBPACK FOOTER //
// ./src/reducers/options/actions.js